module.exports = __webpack_public_path__ + "static/img/logo-mini@2xht.fdf30489.png";